import { useQuery } from '@tanstack/react-query';

import {
  getBrokerConnectionsById,
  type GetBrokerConnectionsByIdResponse,
} from 'wg-api-sdk';

import wgApi from '@/lib/api/wgApi';
import useCurrentBroker from '@/queries/hooks/useCurrentBroker';
import type { QueryOptions } from '@/types/react-query';

import queryKeys from '../queryKeys';

export type OutlookConnection =
  GetBrokerConnectionsByIdResponse['connections'][number];

export function getOutlookConnectionError(
  connection: OutlookConnection | null | undefined,
) {
  if (!connection || connection.active) return undefined;

  return connection.last_error;
}

export default function useOutlookConnection(
  options?: QueryOptions<OutlookConnection | null>,
) {
  const { data: broker } = useCurrentBroker();
  const brokerId = broker?.id ?? '';

  return useQuery({
    queryKey: queryKeys.connection('outlook'),
    queryFn: async () => {
      const { connections } = await getBrokerConnectionsById(
        {
          path: { broker_id: brokerId },
          query: { host: new URL(import.meta.env.VITE_PLATFORM_HOST).host },
        },
        wgApi,
      );

      return (
        connections.find((connection) => connection.key === 'outlook') ?? null
      );
    },
    retry: false,
    refetchOnWindowFocus: true,
    enabled: Boolean(brokerId),
    ...options,
  });
}
